import React, { useState } from "react";
import styles from './Navbar.module.css';
import lupaBackground from "../../../images/Fondolupita.png";
import lupaIcon from "../../../images/LUPA2.png";
import Dropdown from "../../ui/Dropdown";
import DropdownItem from "../../ui/Dropdown/DropdownItem";
import useFuzzySearch from "../../../hooks/useFuzzySearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const SEARCH_FIELD_OPTIONS = [
  { label: 'Nombre', field: 'equipo' },
  { label: 'Marca', field: 'marca' },
  { label: 'Categoría', field: 'categoria' },
  { label: 'Sección', field: 'seccion' },
];

// Buscador del navbar (catálogo e inventario): texto, selector de campo y sugerencias.
const NavbarSearch = ({ productos, searchField, setSearchTerm, setSelectedProductId, setSearchField }) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const fuzzySearch = useFuzzySearch(productos, searchField);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSearchTerm(event.target.value);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm1(value);
    setSearchTerm(value);
    setSelectedProductId(null);
    setSuggestions(value ? fuzzySearch(value) : []);
  };

  const handleSearchFieldChange = (field) => {
    setSearchField(field);
    setSearchTerm1("");
    setSearchTerm("");
    setSelectedProductId(null);
    setSuggestions([]);
  };

  const handleClearSearch = () => {
    setSearchTerm1("");
    setSearchTerm("");
    setSelectedProductId(null);
    setSuggestions([]);
  };

  const handleSuggestionClick = (producto) => {
    setSearchTerm1(producto.equipo);
    setSearchTerm(producto.equipo);
    setSelectedProductId(producto.id);
    setSuggestions([]);
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setTimeout(() => setIsFocused(false), 200); // Para permitir la selección del elemento de la lista
  };

  return (
    <section className="search-section mt-0">
      <div className="search-container">
        <div className={styles.searchInputWrapper}>
          <input
            type="text"
            value={searchTerm1}
            onChange={handleSearchChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyPress}
            className={styles.searchInput}
            placeholder={isFocused ? "" : "Buscar"}
            style={{ marginLeft: "10px" }} // Añade margen izquierdo al input
          />
          <img
            src={lupaBackground}
            alt="lupa background"
            className={styles.lupaBackground}
          />
          <img src={lupaIcon} alt="lupa icon" className={styles.lupaIcon} />
          {searchTerm1 && (
            <button
              type="button"
              className={styles.searchClearBtn}
              onClick={handleClearSearch}
              aria-label="Limpiar búsqueda"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          )}
          <div className={styles.searchFieldDropdown}>
            <Dropdown
              variant="compact"
              buttonText={SEARCH_FIELD_OPTIONS.find(o => o.field === searchField)?.label || 'Nombre'}
              content={
                <>
                  {SEARCH_FIELD_OPTIONS.map(opt => (
                    <DropdownItem key={opt.field} onclick={() => handleSearchFieldChange(opt.field)}>
                      {opt.label}
                    </DropdownItem>
                  ))}
                </>
              }
            />
          </div>
          {isFocused && suggestions.length > 0 && (
          <ul className={styles.suggestions}>
            {suggestions.map((producto) => (
              <li
                key={producto.id}
                className={styles.suggestionItem}
                onClick={() => handleSuggestionClick(producto)}
              >
                {producto.equipo}
                {producto.marca && (
                  <span className={styles.suggestionMarca}> - {producto.marca}</span>
                )}
              </li>
            ))}
          </ul>
          )}
        </div>
      </div>
    </section>
  );
};

export default NavbarSearch;
